import { ParagraphSkeletonLoading, getSize, getColor } from '@lib/common';
import styled from 'styled-components';
import { useSectionSummary } from './hooks/use-section-summary';
import { SectionItemComponent } from './components';
import { HeaderComponent } from './header.component';
import Image from 'next/image';
import { useEffect, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Layout = styled.div.withConfig({
  displayName: "section-summary-v2component__Layout",
  componentId: "sc-zf6xv1-0"
})(["display:flex;flex-direction:column;height:inherit;background-color:", ";"], getColor('fillBgWhite'));
var StyledSectionSummaryWrapper = styled.div.withConfig({
  displayName: "section-summary-v2component__StyledSectionSummaryWrapper",
  componentId: "sc-zf6xv1-1"
})(["display:flex;flex-direction:column;gap:", ";overflow-y:auto;height:auto;max-height:calc(100vh - 200px);padding:", " ", " ", ";::-webkit-scrollbar{width:6px;}::-webkit-scrollbar-track{border-radius:3px;}::-webkit-scrollbar-thumb{background-color:#c4ccd7;border-radius:3px;}::-webkit-scrollbar-thumb:hover{background-color:#a8b3c1;}scrollbar-width:thin;scrollbar-color:#c4ccd7 #e9edf2;@supports (overflow:overlay){overflow:overlay;}"], getSize('padding4'), getSize('padding16'), getSize('padding8'), getSize('padding32'));
export var SectionSummaryPanelV2Component = function SectionSummaryPanelV2Component(_ref) {
  var selectedFormItemId = _ref.selectedFormItemId,
      sectionSummaries = _ref.sectionSummaries,
      questions = _ref.questions,
      formTotalQuestions = _ref.formTotalQuestions,
      formTotalScore = _ref.formTotalScore,
      hasUnsavedQuestionOrSectionChanges = _ref.hasUnsavedQuestionOrSectionChanges,
      onSelectQuestion = _ref.onSelectQuestion,
      onSelectedSection = _ref.onSelectedSection,
      sectionFocusedId = _ref.sectionFocusedId,
      labelTranslation = _ref.labelTranslation;

  var _useSectionSummary = useSectionSummary({
    questions: questions
  }),
      getQuestionsBySectionId = _useSectionSummary.getQuestionsBySectionId;

  var wrapperRef = useRef(null); // Scroll to focused section when sectionFocusedId changes

  useEffect(function () {
    if (sectionFocusedId && wrapperRef.current) {
      var sectionElement = document.getElementById("".concat(sectionFocusedId, "-panel"));

      if (sectionElement) {
        // Use setTimeout to ensure DOM is ready
        var timeoutId = setTimeout(function () {
          sectionElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }, 100);
        return function () {
          return clearTimeout(timeoutId);
        };
      }
    }
  }, [sectionFocusedId]);

  var renderSectionSummaries = function renderSectionSummaries() {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: sectionSummaries === null || sectionSummaries === void 0 ? void 0 : sectionSummaries.map(function (section, sectionIndex) {
        var questionsBySectionId = getQuestionsBySectionId(section.id.toString());
        return /*#__PURE__*/_jsx(SectionItemComponent, {
          section: section,
          sectionIndex: sectionIndex,
          questions: questionsBySectionId,
          selectedFormItemId: selectedFormItemId,
          sectionFocusedId: sectionFocusedId,
          hasUnsavedQuestionOrSectionChanges: hasUnsavedQuestionOrSectionChanges,
          onSelectedSection: onSelectedSection,
          onSelectQuestion: onSelectQuestion,
          labelTranslation: labelTranslation
        }, section.id.toString());
      })
    });
  };

  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsx(HeaderComponent, {
      pointIcon: /*#__PURE__*/_jsx(Image, {
        src: "/icons/trophy.svg",
        width: 16,
        height: 16,
        alt: "trophy"
      }),
      totalQuestionScore: formTotalScore,
      totalQuestions: formTotalQuestions,
      labelTranslation: labelTranslation
    }), /*#__PURE__*/_jsx(StyledSectionSummaryWrapper, {
      ref: wrapperRef,
      children: sectionSummaries ? renderSectionSummaries() : /*#__PURE__*/_jsx(ParagraphSkeletonLoading, {
        rows: 10
      })
    })]
  });
};